/**
 * SoleadLab 2.0 — Route Guard
 *
 * Redirects to /login if not authenticated; redirects authenticated users
 * with no org memberships to /onboarding (so they can't reach /editor with
 * an empty tenant context, which would otherwise render but show no data
 * — and historically leaked sites from other tenants via the listSites
 * fallthrough).
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const orgs = useAuthStore(s => s.orgs);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Tenant guard: no orgs means onboarding isn't done. /onboarding itself
  // is also wrapped in RequireAuth but bypasses this check (it IS the
  // destination).
  if (orgs.length === 0 && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
